import { render } from "./ChampionshipsRequestDetails.vue?vue&type=template&id=35dfd7e3&scoped=true"
import script from "./ChampionshipsRequestDetails.vue?vue&type=script&lang=js"
export * from "./ChampionshipsRequestDetails.vue?vue&type=script&lang=js"

import "./ChampionshipsRequestDetails.vue?vue&type=style&index=0&id=35dfd7e3&scoped=true&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dfd7e3"]])

export default __exports__